export const SINGLE_ROW_COUNT = 8;
